// extracted by mini-css-extract-plugin
export default {"root":"OfferMenu_root__bPUSK","dropdown":"OfferMenu_dropdown__dS202","movein":"OfferMenu_movein__fG9a8"};